<template>

	<div class="comment-wrap user">
		<!-- USER AVATAR -->
			<figure class="user-avatar medium">
                <img :src="'/images/avatars/'+comment.user.avatar" alt="user avatar">
			</figure>
		<!-- /USER AVATAR -->
		<div class="comment">
			<p v-if="comment.read_at != null" :title="'Read: ' + readAt" class="report tooltip">{{comment.created_at | fromNowAgo}}</p>
			<p v-else class="report">{{comment.created_at | fromNowAgo}}</p>

            <p class="text-header">{{comment.user.name}}</p>
			<!-- PIN -->
			<span class="pin greyed">Approved the paper</span>
			<!-- /PIN -->
			<br>

			<ul class="rating">
				<li v-for="x in comment.commentable.mark" class="rating-item">
					<i class="fa fa-star" aria-hidden="true"></i>
				</li>

				<li v-for="x in (10 - comment.commentable.mark)" class="rating-item empty">
					<i class="fa fa-star" aria-hidden="true"></i>
				</li>

				<li  class="rating-item">
					<span class="rating-number"><strong>{{comment.commentable.mark}}</strong> /10</span>
				</li>
			</ul>

			<div class="quote primary">
				<p class="text-header small">Customer's feedback:</p>
				<p class="message">{{comment.body}}</p>
			</div>
		</div>
	</div>
</template>


<script>

    export default {
        props: ['comment'],
        data() {
            return {

            }
        },

        created(){
            this.loading = false;
        },

		computed: {
			readAt: function () {
				return this.$options.filters.fromNowAgo(this.comment.read_at);
			}
		},

    }
</script>